import NavbarDWP from "./component/NavbarDWP.js";
import Hero from "./component/Hero.js";
import About from "./component/About.js";
import MissionVision from "./component/MissionVision.js";
import WhyChoose from "./component/WhyChoose.js";
import Courses from "./component/Courses.js";
import LearningJourney from "./component/LearningJourney.js";
import StudentBenefits from "./component/StudentBenefits.js";
import FAQ from "./component/FAQ.js";
import Contact from "./component/Contact.js";
import CTA from "./component/CTA.js";
import Footer from "./component/Footer.js";

function App() {
  return (
    <>
      <NavbarDWP />
      <Hero />
      <About/>
      <MissionVision/>
      <WhyChoose/>
      <Courses/>
      <LearningJourney/>
      <StudentBenefits/>
      <FAQ/>
      <Contact/>
      <CTA/>
      <Footer/>
    </>
  );
}

export default App;